/**
 * Maximum number of images allowed in a property or unit gallery.
 *
 * Shared by the upload dialogs (`maxFiles`) and the gallery modal
 * (`maxImages`) so the limit lives in exactly one place.
 */
export const MAX_GALLERY_IMAGES = 100;
